import CheckList from './CheckList'
import './CheckList.scss'

export type { CheckListItem } from './CheckList'
export default CheckList